import styled from 'styled-components'

const FieldSet = styled.fieldset`
  border: 0;
  padding: 0.01em 0 0 0;
  margin: 0;
  min-width: 0;
  width: 100%;
  display: table-cell;
`

/** @component */
export default FieldSet
